export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-900 text-background-100 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20gradient%20with%20warm%20subtle%20orange%20glow%20accents%2C%20minimalist%20geometric%20patterns%2C%20premium%20tech%20background%2C%20soft%20radial%20light%20from%20center%2C%20modern%20digital%20aesthetic&width=1600&height=600&seq=durian-app-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-background-50/15 text-background-200 text-xs font-medium mb-4 whitespace-nowrap">
          APP下载
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
          移动端观影，随时随地
        </h2>
        <p className="text-sm md:text-base text-background-300 max-w-xl mx-auto leading-relaxed mb-8">
          榴莲视频移动端同步支持97视频、丝瓜视频、蓝莓视频、91在线视频等平台信息查询，轻量设计、流畅体验。随时随地获取在线视频平台最新对比导航。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#"
            className="px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-900 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-android-line text-lg"></i>
            Android 下载
          </a>
          <a
            href="#"
            className="px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-100 border border-background-50/25 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-apple-line text-lg"></i>
            iOS 下载
          </a>
        </div>
        <p className="mt-4 text-xs text-background-400">
          移动端为信息查询工具，不提供视频播放功能
        </p>
      </div>
    </section>
  );
}